import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserManagementService } from 'src/app/Service/user-management.service';
const trimValidator: ValidatorFn = (text: FormControl) => {
  if (text.value.startsWith(' ')) {
    return {
      'trimError': { value: 'text has leading whitespace' }
    };
  }
  if (text.value.endsWith(' ')) {
    return {
      'trimError': { value: 'text has trailing whitespace' }
    };
  }
  return null;
};

@Component({
  selector: 'app-manage-market',
  templateUrl: './manage-market.component.html',
  styleUrls: ['./manage-market.component.scss']
})
export class ManageMarketComponent implements OnInit {

  form: FormGroup;
  submitted = false;
  uploadedImage: File;
  marketForm: FormGroup;
  success;
  insertscheme;
  alertMessage: any;
  manageMarket: any[];
  dataSource: any;
  selectedIndex: number;
  paginator: any;
  reg: string | RegExp;
  marketdata;
  marketdatalist = [];
  marketId;
  constructor(private datepipe: DatePipe, private router: Router, private spinner: NgxSpinnerService,
    private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private dialog: MatDialog, public dialogRef: MatDialogRef<ManageMarketComponent>) { }


  ngOnInit(): void {
    this.marketForm = this.fb.group({
      marketName: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      Remark: []
    });

    this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    let marketName = "";
    let result = marketName.trim();
    this.getManageMarket();
    this.getActiveMarket();
  }

  getmarketId(id) {
    this.marketId = id
  }


  getManageMarket() {
    this._userService.getMarketlist().subscribe(data => {
      this.marketdata = data
      this.marketdatalist = this.marketdata.result.data
    });
  }

  getActiveMarket() {
    this.spinner.show();
    var postdata = {
      "removeMarketList": this.selectedItems
    }
    this._userService.getActiveMarket(postdata).subscribe(data => {
      this.alertMessage = data['result']
    });
    return this.alertMessage
  }

  addManageMarketList() {

    var manageMarketPostData = {
      "marketName": this.marketForm.value.marketName
    }
    if(this.marketForm.valid){
      this._userService.addManageMarket(manageMarketPostData).subscribe(data => {
        if (data['result'].data == 1) {
          this.toastr.success(data['result'].message, 'Success', {
            timeOut: 3000,
          });
          this.marketForm.reset();
          this.getManageMarket();
        }
  
        else {
          this.toastr.error(data['result'].message, 'Error', {
            timeOut: 3000,
          });
        }
      });
    }else{
      this.toastr.error("Please fill the market name")
    }

    this.getManageMarket();
  }

  onSubmit() {
    if (this._userService.form.valid) {
      this._userService.insertscheme(this._userService.form.value);
      this._userService.form.reset();
      this._userService.success("Submitted successfully");
      this.onClear();
    }
  }
  selectedItems: any = []
  itemToDelete(marketItems, event: Event) {
    if (this.selectedItems.find(x => x == marketItems)) {
      this.selectedItems.splice(this.selectedItems.indexOf(marketItems), 1)
    } else {
      this.selectedItems.push(marketItems)
    }

  }
  onClear() {
    this.dialogRef.close();
    // setTimeout("location.reload(true);", 500);
    this.router.navigate(['/MarketPlace'])
  }
  /*model pop up same page  */
  deletemarket() {
    if (this.selectedItems.length > 0) {
      var postdata = {
        "removeMarketList": this.selectedItems
      }
      this._userService.getActiveMarket(postdata).subscribe(resp => {
        if (resp['result']['data'] == 1) {
          var dialogRef = this.dialog.open(DeleteManageMarket, {
            width: '35%',
            height: '36%',
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result.result === 'Yes') {
              this.selectedItems.map(ele => {
                ele.remark = result.remark
                delete ele.marketId
              })
              const deleteBody = {
                removeMarketList: this.selectedItems
              }
              this._userService.removeManageMarket(deleteBody).subscribe(data => {
                if (data['result'].data == 1) {
                  this.toastr.success(data['result'].message, 'Success', {
                    timeOut: 3000,
                  });
                  this.selectedItems = [];
                  this.getManageMarket();
                }
              });
            }
          });
        } else {
          this.toastr.error(resp['result']['message'], 'Error', {
            timeOut: 3000,
          });
        }
      });
    }
    else {
      this.toastr.warning('Please select any one market!', 'Info', {
        timeOut: 3000,
      });
    }

  }
}
/* */
@Component({
  selector: 'delete-manage-market',
  templateUrl: 'delete-manage-market.html',
})
export class DeleteManageMarket {
  formDelete: FormGroup;
  response;
  marketId;
  constructor(
    public dialogRef: MatDialogRef<DeleteManageMarket>,
    @Inject(MAT_DIALOG_DATA) public data: any, private fb: FormBuilder, public _userService: UserManagementService, public toastr: ToastrService, private router: Router) { }

  ngOnInit(): void {
    this.formDelete = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit(value: any) {
    if (this.formDelete.valid) {
      var deleteItems = {
        result: value,
        remark: this.formDelete.value.Remark

      }


      this.dialogRef.close(deleteItems);
    }
    else {
      alert("Please Enter the valid remark!")
    }
  }
  onNoClicks(value): void {
    this.dialogRef.close(value);
  }



}
